@let controlValue = control();
@if (controlValue) {
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>{{label()}}</mat-label>
    <mat-select matInput [formControl]="controlValue" [placeholder]="placeholder()" [required]="required()" [errorStateMatcher]="errorStateMatcher()">
      @if(useEmpty()) {
        <mat-option [value]="''">{{emptyLabel()}}</mat-option>
      }
      @for(option of selectOptions(); track option.value) {
        <mat-option [value]="option.value">{{option.label}}</mat-option>
      }
    </mat-select>
    @if (help()) {
      <mat-icon matSuffix [matTooltip]="help()" class="form-field__help-icon">help</mat-icon>
    }
    <mat-error>{{error()}}</mat-error>
  </mat-form-field>
}
